import authStore from './AuthStore';
import cauzeStore from './CauzeStore';
import cauzePurchaseStore from './CauzePurchaseStore';
import charitiesStore from './CharitiesStore';
import charityAdminStore from './CharityAdminStore';
import companiesStore from './CompaniesStore';
import companyAdminStore from './CompanyAdminStore';
import companyReportingStore from './CompanyReportingStore';
import companyGiftsStore from './CompanyGiftsStore';
import createMatchStore from './CreateMatchStore';
import influencersStore from './InfluencersStore';
import influencerDashboardStore from './InfluencerDashboardStore';
import usersStore from './UsersStore';
import eventStore from './EventStore';
import profileStore from './ProfileStore';
import addFundsGiftCheckoutStore from './AddFundsGiftCheckoutStore';
import uiStore from './UiStore';
import userProfileStore from './UserProfileStore';
import companyStore from './CompanyStore';
import charityStore from './CharityStore';
import entityGiftsStore from './EntityGiftsStore';
import donationLandingStore from './DonationLandingStore';
import userDetailsStore from './UserDetailsStore';
import matchStore from './MatchStore';
import followFollowingStore from './FollowFollowingStore';
import localFeedStore from './LocalFeedStore';
import userReportsStore from './UserReportsStore';

const stores = {
  authStore,
  uiStore,
  userProfileStore,
  cauzeStore,
  cauzePurchaseStore,
  charitiesStore,
  charityAdminStore,
  companiesStore,
  companyAdminStore,
  companyReportingStore,
  companyGiftsStore,
  createMatchStore,
  eventStore,
  profileStore,
  addFundsGiftCheckoutStore,
  influencersStore,
  influencerDashboardStore,
  usersStore,
  companyStore,
  charityStore,
  entityGiftsStore,
  donationLandingStore,
  userDetailsStore,
  matchStore,
  followFollowingStore,
  localFeedStore,
  userReportsStore,
};

export default stores;
